// src/components/Herbarium.js
import React from 'react';

function Herbarium({ discoveredFlowers, onSelectFlower, onClose }) {
  if (discoveredFlowers.length === 0) {
    return (
      <div className="herbarium">
        <h2>Mi Herbario</h2>
        <p>Aún no has descubierto ninguna flor. ¡Juega para coleccionarlas!</p>
        <button onClick={onClose}>Volver al Menú</button>
      </div>
    );
  }

  return (
    <div className="herbarium">
      <h2>Mi Herbario ({discoveredFlowers.length} flores)</h2>
      <button onClick={onClose} className="close-button">Volver</button>
      <div className="herbarium-grid">
        {discoveredFlowers.map(flower => (
          <div key={flower.id} className="herbarium-item" onClick={() => onSelectFlower(flower)}>
            <img src={process.env.PUBLIC_URL + flower.imagenUrl} alt={flower.nombreComun} />
            <p>{flower.nombreComun}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Herbarium;